module.exports = __webpack_public_path__ + "static/img/4.41e8351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/4.png
// module id = pY7f
// module chunks = 0